import { Modal, ModalWidth, useGlobalModalContext } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { ContactInformation } from '../../../../components/ContactInformation';
import { SUBSCRIPTION_HEADER } from '../../../../components/LockedContent/LockedContent.constants';
import styles from './LockedContentModal.module.scss';

const cx = classNames.bind(styles);

const LockedContentModal = (): ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal
      dataTestId="locked-content-modal"
      headerTitle={SUBSCRIPTION_HEADER}
      onClose={closeModal}
      width={ModalWidth.Medium}
      className={cx('body')}
      open
    >
      <p>
        {'Please contact your account representative '}
        <ContactInformation showClientService showAssignedAccountManager emailAddress="" />
        {' to access this content.'}
      </p>
    </Modal>
  );
};

export default LockedContentModal;
